import config from "@shared/config/client";

async function getRates() {
  const result = await fetch(`${config.apiUrl}/rates`, { method: "GET" });

  return await result.json();
}

async function getEtherRate() {
  const result = await fetch(`${config.apiUrl}/rates/ether`, { method: "GET" });

  return await result.json();
}

async function getPolRate() {
  const result = await fetch(`${config.apiUrl}/rates/pol`, { method: "GET" });

  return await result.json();
}

async function getWPolRate() {
  const result = await fetch(`${config.apiUrl}/rates/wpol`, { method: "GET" });

  return await result.json();
}

async function getTurboRate() {
  const result = await fetch(`${config.apiUrl}/rates/turbo`, { method: "GET" });

  return await result.json();
}

async function getUsdtRate() {
  const result = await fetch(`${config.apiUrl}/rates/usdt`, { method: "GET" });

  return await result.json();
}

export {
  getRates,
  getEtherRate,
  getPolRate,
  getWPolRate,
  getTurboRate,
  getUsdtRate,
};
